module.exports = __webpack_public_path__ + "img/dia_do_orgulho_nerd.252516de.svg";